import type { Student } from "./types";

export type ScoreRange = {
  columnId: string;
  component?: "multipleChoice" | "written";
  anchorId: string;
  endId: string;
};

export function scoreRangeStudents(students: Student[], range: ScoreRange | null) {
  if (!range) return [];
  const anchor = students.findIndex((student) => student.id === range.anchorId);
  const end = students.findIndex((student) => student.id === range.endId);
  if (anchor < 0 || end < 0) return [];
  return students.slice(Math.min(anchor, end), Math.max(anchor, end) + 1);
}

export function scoreRangeValues(students: Student[], range: ScoreRange) {
  return scoreRangeStudents(students, range).map((student) => range.component
    ? student.components[range.columnId]?.[range.component] ?? null
    : student.scores[range.columnId] ?? null);
}

export function scoreColumnClipboard(values: (number | null)[]) {
  // A row terminator also preserves blank cells at the end when pasted into a sheet.
  return values.length ? values.map((value) => value === null ? "" : String(value)).join("\n") + "\n" : "";
}
